import useRouteLoadingSpan from '../../../../hooks/useRouteLoadingSpan';
import Loader from '../../Loader';

const RouteLoader = () => {
  useRouteLoadingSpan();
  return <Loader />;
};

export default RouteLoader;
